import { Text } from "@chakra-ui/react";

export default function index() {
  return (
    <Text
      className="blink-me"
      variant="priceText"
      borderColor="maroon"
      mt={{ base: "5px", sm: "0px" }}
      ml={{ base: "0px", sm: "5px" }}
      fontSize={{ base: "12", lg: "13", xl: "14" }}
    >
      (Diwali holidays from 16th till 27th October 2025. Orders placed during
      this period will be shipped on 28th October 2025.
      <br />
      दिवाली छुट्टियां 16 दिन से 27 दिन तक 2025 में। इस अवधि में रखे गए आदेशों
      को 28 दिन अक्टूबर 2025 को भेजा जाएगा।)
    </Text>
  );
}
